import { render, staticRenderFns } from "./ferring.vue?vue&type=template&id=14a7f842&"
import script from "./ferring.vue?vue&type=script&lang=js&"
export * from "./ferring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ferring.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CaseIntro: require('/app/components/case/intro.vue').default,CaseContent: require('/app/components/case/content.vue').default,UiTransition: require('/app/components/ui/transition.vue').default,CaseList: require('/app/components/case/list.vue').default,CaseCta: require('/app/components/case/cta.vue').default,CaseRelated: require('/app/components/case/related.vue').default})
